import React from 'react'
import { useRef } from 'react';
import Slider from "react-slick";

import MagicSliderDots from 'react-magic-slider-dots';
import 'react-magic-slider-dots/dist/magic-dots.css';
import { LeftIcons, RightIcons } from '../Icons/Icons';

const SliderTestimonial = () => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: dots => {
            return <MagicSliderDots dots={dots} numDotsToShow={3} dotWidth={20} />;
        },
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    const slider1 = useRef(null);

    const previous = () => {
        slider1.current.slickNext();
    };

    const next = () => {
        slider1.current.slickPrev();
    };
    return (
        <div className="position-relative">
            <div className="wrapper__arrow-width">
                <div className='pointer left' onClick={previous}>
                    <LeftIcons />
                </div>
                <div className='pointer right' onClick={next}>
                    <RightIcons />
                </div>

            </div>
            <Slider ref={slider1} {...settings} className='wrapper__slider-testimonial'>
                <div className="items">
                    <div className="wrapper__card-testi position-relative">
                        <div className="d-flex align-items-start">
                            <img src="./../images/quote-up.png" className='logo' alt="" />
                            <div className='ml-2'>
                                <p className='medium font__size--14 text__14-1024 color__gray-2 mb-2'>Member Review</p>
                                <h5 className='normal font__size--24 text__24-1024 lh__4 mb-4'>"Dr. Aya Belal completely changed my approach to health! With her guidance, I lost 12kg in 3 months without feeling deprived. Her meal plans were easy to follow and actually enjoyable. I feel healthier, energized, and more confident than ever!". </h5>
                                <div className="d-flex align-items-center user">
                                    <img src="./../images/Ellipse 3.png" alt="" />
                                    <div className='ml-2 text-left'>
                                        <h5 className='medium font__size--16 text__16-1024 mb-0'>Mona A.</h5>
                                        <p className='mb-0 normal font__size--14 text__14-1024'>Member</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="items">
                    <div className="wrapper__card-testi position-relative">
                        <div className="d-flex align-items-start">
                            <img src="./../images/quote-up.png" className='logo' alt="" />
                            <div className='ml-2'>
                                <p className='medium font__size--14 text__14-1024 color__gray-2 mb-2'>Member Review</p>
                                <h5 className='normal font__size--24 text__24-1024 lh__4 mb-4'>"I struggled with weight for years, but Dr. Aya made it simple and sustainable. I lost 8kg over 2 months while still enjoying my favorite foods. Her personalized tips and support kept me motivated every step of the way. Truly life-changing!" </h5>
                                <div className="d-flex align-items-center user">
                                    <img src="./../images/Ellipse 4.png" alt="" />
                                    <div className='ml-2 text-left'>
                                        <h5 className='medium font__size--16 text__16-1024 mb-0'>Sara H.</h5>
                                        <p className='mb-0 normal font__size--14 text__14-1024'>Member</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="items">
                    <div className="wrapper__card-testi position-relative">
                        <div className="d-flex align-items-start">
                            <img src="./../images/quote-up.png" className='logo' alt="" />
                            <div className='ml-2'>
                                <p className='medium font__size--14 text__14-1024 color__gray-2 mb-2'>Member Review</p>
                                <h5 className='normal font__size--24 text__24-1024 lh__4 mb-4'>"Thanks to Dr. Aya Belal, I finally gained the healthy weight I’ve always wanted! She designed a plan tailored to my body type and lifestyle, focusing on nutrition that actually nourishes me. I feel stronger, more energetic, and confident in my own skin!"
                                </h5>
                                <div className="d-flex align-items-center user">
                                    <img src="./../images/Ellipse 5.png" alt="" />
                                    <div className='ml-2 text-left'>
                                        <h5 className='medium font__size--16 text__16-1024 mb-0'>Lina F.</h5>
                                        <p className='mb-0 normal font__size--14 text__14-1024'>Member</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    )
}

export default SliderTestimonial